import { useFilters } from "../../Common/Hooks/useFilters";
import { Filter } from "./Filtering";

import './DateRangeFilterSummary.css'

export interface DateRangeFilterSummaryProps {
	filter: Filter
}

export function DateRangeFilterSummary(props: DateRangeFilterSummaryProps): JSX.Element {

	const { removeFilter, setFilter } = useFilters()

	return (
		<div className='filter'>
			<span className='filter-title'>Date range:</span>
			<span className="filter-item"><button className='link-button remove' onClick={ clearFilter }>&times;</button>
				<input type="date" value={ props.filter.values[0] } onChange={ (e) => startDateChanged(e) } /> to <input type="date" value={ props.filter.values[1] } onChange={ (e) => endDateChanged(e) } />
			</span>
		</div>
	)

	function startDateChanged(e: React.ChangeEvent<HTMLInputElement>): void {
		const newDate = e.target.value || '0001-01-01'
		setFilter('dateRange', [newDate, props.filter.values[1]])
	}

	function endDateChanged(e: React.ChangeEvent<HTMLInputElement>): void {
		const newDate = e.target.value || '9999-12-31'
		setFilter('dateRange', [props.filter.values[0], newDate])
	}

	function clearFilter(): void {
		removeFilter('dateRange')
	}

}
